import {GemSettings} from 'app/utils/config/interface';

/**
 * Should components lazy load on page load.
 * @param gemSettings
 */
export function getLazyLoadPage(gemSettings: GemSettings) {
    const noHash = window.location.hash.substring(1) === '';
    return Boolean(gemSettings.lazyLoadJS && gemSettings.wcmMode === 'DISABLED' && noHash);
}
